import { FC } from 'react';
import { Button } from 'components/atoms/Button';
import { CircularProgress } from 'components/atoms/CircularProgress';
import { DialogComponentProps } from '../type';

interface DialogFooterProps {
  onClose: () => void;
  onSubmit?: () => void;
  variant: DialogComponentProps['variant'];
  submitButtonLabel?: string;
  isLoading: boolean;
  startIcon?: React.ReactNode;
  cancelButtonLabel?: string;
  hideCancelButton?: boolean;
  disabled?: boolean;
}

export const DialogFooter: FC<DialogFooterProps> = ({
  onClose,
  onSubmit,
  variant,
  submitButtonLabel = 'Save',
  isLoading = false,
  startIcon,
  cancelButtonLabel = 'Cancel',
  hideCancelButton = false,
  disabled = false,
}) => (
  <>
    {!hideCancelButton && (
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        disabled={isLoading}
        onClick={onClose}
      >
        {cancelButtonLabel}
      </Button>
    )}
    {onSubmit && (
      <Button
        type="submit"
        color={variant}
        variant="contained"
        size="small"
        onClick={onSubmit}
        disabled={isLoading || disabled}
        startIcon={(isLoading && <CircularProgress size={16} />) || startIcon}
      >
        {submitButtonLabel}
      </Button>
    )}
  </>
);
